import Vue from 'vue';
import Router from 'vue-router';
import firebase from 'firebase/app';
import 'firebase/auth';

const Home = () => import('../views/Home.vue');
const Biography = () => import('../views/Biography.vue');
const Bibliography = () => import('../views/Bibliography.vue');
const AlbumDetails = () => import('../views/AlbumDetails.vue');
const News = () => import('../views/News.vue');
const Login = () => import('../views/Login.vue');

Vue.use(Router);

const router = new Router({
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home,
    },
    {
      path: '/biography',
      name: 'Biography',
      component: Biography,
    },
    {
      path: '/bibliography',
      name: 'Bibliography',
      component: Bibliography,
    },
    {
      path: '/bibliography/:albumId',
      name: 'AlbumDetails',
      component: AlbumDetails,
      props: true,
    },
    {
      path: '/login',
      name: 'Login',
      component: Login,
    },
    {
      path: '/news',
      name: 'News',
      component: News,
      meta: {
        requiresAuth: true,
      },
    },
  ],
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  },
});

router.beforeEach((to, from, next) => {
  const currentUser = firebase.auth().currentUser;
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth);

  if (requiresAuth && !currentUser) next('Login');
  else if (!requiresAuth) next();
  else next();
});

export default router;
